import { PATHS, ELEMENT_TYPE } from '../config/constants';
import translations from './index';

const { momentTitle, momentDesc, general } = translations;

export default {
  EV02: {
    id: 'EV02',
    title: momentTitle.EV02,
    text: '',
    year: '1919',
    theme: 'black',
    description: momentDesc.EV02,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV02/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV02/HeroMobile.jpg',
    relatedText: '',
    type: ELEMENT_TYPE.MOMENT,
    related: [],
    nextProduct: {
      id: 'EV03',
      text: general.nextEvent,
      url: `${PATHS.MOMENT}/EV03`,
      type: ELEMENT_TYPE.MOMENT,
    },
  },
  EV03: {
    id: 'EV03',
    title: momentTitle.EV03,
    text: '',
    year: '1952',
    theme: 'black',
    description: momentDesc.EV03,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV03/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV03/HeroMobile.jpg',
    relatedText: '',
    type: ELEMENT_TYPE.MOMENT,
    related: [],
    nextProduct: {
      id: 'EV04',
      text: general.nextEvent,
      url: `${PATHS.MOMENT}/EV04`,
      type: ELEMENT_TYPE.MOMENT,
    },
  },
  EV04: {
    id: 'EV04',
    title: momentTitle.EV04,
    text: '',
    year: '1953',
    theme: 'black',
    description: momentDesc.EV04,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV04/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV04/HeroMobile.jpg',
    relatedText: '',
    type: ELEMENT_TYPE.MOMENT,
    related: [],
    nextProduct: {
      id: 'EV05',
      text: general.nextEvent,
      url: `${PATHS.MOMENT}/EV05`,
      type: ELEMENT_TYPE.MOMENT,
    },
  },
  EV05: {
    id: 'EV05',
    title: momentTitle.EV05,
    text: '',
    year: '1955',
    theme: 'black',
    description: momentDesc.EV05,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV05/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV05/HeroMobile.jpg',
    relatedText: '',
    type: ELEMENT_TYPE.MOMENT,
    related: [],
    nextProduct: {
      id: 'EV06',
      text: general.nextEvent,
      url: `${PATHS.MOMENT}/EV06`,
      type: ELEMENT_TYPE.MOMENT,
    },
  },

  EV06: {
    id: 'EV06',
    title: momentTitle.EV06,
    text: '',
    year: '1956',
    theme: 'white',
    description: momentDesc.EV06,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV06/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV06/HeroMobile.jpg',
    relatedText: '',
    type: ELEMENT_TYPE.MOMENT,
    related: [],
    nextProduct: {
      id: 'EV07',
      text: general.nextEvent,
      url: `${PATHS.MOMENT}/EV07`,
      type: ELEMENT_TYPE.MOMENT,
    },
  },

  EV07: {
    id: 'EV07',
    title: momentTitle.EV07,
    text: '',
    year: '1977 - 1979',
    theme: 'black',
    description: momentDesc.EV07,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV07/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/moments/EV07/HeroMobile.jpg',
    relatedText: '',
    type: ELEMENT_TYPE.MOMENT,
    related: [],
    nextProduct: {
      id: 'EV02',
      text: general.nextEvent,
      url: `${PATHS.MOMENT}/EV02`,
      type: ELEMENT_TYPE.MOMENT,
    },
  },
};
